<template>
	<div>
		<TableView
			:onSearch="getConsultaEmail"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:pagination="pagination"
			disabledConfigCell
			disableCheckAll
		/>
	</div>
</template>

<script>
	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Fct from 'common/fct'

  	export default {
  		name:"empresa",
  		components: {TableView},
		mixins:[Rest,Fct],
		props:{
			parent:{
				type:Object,
				default:null
			},
		},
		watch:{
			'parent.showDownloadASO'(){
				this.getConsultaEmail();
			},
			'parent.consulta.id'(){
				this.getConsultaEmail();
			}
		},
  		data () {
		   	return {
				pagination:{},
				error:{},
		   		tableHead:[
					{
		                key: 'data',
						sortable: true,
						width:'120px',
						label: 'Data',
					},
					{
		                key: 'usuario',
						sortable: true,
						label: 'Usuário',
					},
					{
		                key: 'lote',
						sortable: true,
						width:'55px',
						label: 'Lote',
					},
					{
		                key: 'consulta',
						sortable: true,
						show_tipo_aso:true,
						show_consulta_link:true,
						label: 'Consulta',
					},
					{
		               	key: 'remetente',
						sortable: true,
						label: 'Remetente',
					},
					{
		               	key: 'destinatario',
						sortable: true,
						show_html:true,
						label: 'Destinatário',
					},
					{
		               	key: 'obs',
						sortable: true,
						limit:20,
						label: 'Obs',
					},
					{
		                key: 'documento',
						sortable: true,
						show_html:true,
						label: 'Documento',
					},
					{
		                key: 'status',
						sortable: true,
						show_status:true,
						label: 'Status',
					},

		   		],
				tableData:[],
				loadingTable:false,

			}
		},
		beforeDestroy(){
			this.tableData = [];
		},
		created(){
		},

		mounted: function() {
      this.getConsultaEmail();

      this.$events.on('onClienteEvent', eventData => {
        this.getConsultaEmail();
      });

      this.$on('onTabHistoricoOpened', () => {
        this.getConsultaEmail();
      });
    },

		methods: {
			delay(ms) {
				return new Promise((resolve) => setTimeout(resolve, ms));
			},

			getConsultaEmail: async function(_search,_page,_pagination){
				this.loadingTable = true;

				await this.delay(500);

				this.get('empresa/consulta/email/'+(this.parent.consulta ? this.parent.consulta.id_con : 0),{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					 result = result[0];

		             if(result.status == 200){
		             	this.formataData(result);
		             }
	            });
			},

			formataData: function(result){
				var data = result.data.data,
					tableData = [],
					self = this,
					pagination = result.data;

				for (var i = 0; i < data.length; i++) {

					var fdt = (data[i].fdt ? data[i].fdt.pcmso+' ('+data[i].fdt.descricao+')' : ''),
					    select_pages = '';

					var arr = data[i].destinatario.split(';'),destinatario = '', msg = '';

					for (let j = 0; j < arr.length; j++) {
						var title = '';

						if(data[i].abertura && data[i].abertura[arr[j]]){
							var abertura = data[i].abertura[arr[j]],
								aux = 'Email visualizado em '+this.toDate(abertura.data)+'\n'+'Endereço IP '+abertura.ip;

							title = '<i class="fa fa-eye" title="'+aux+'"></i> '
						}
						destinatario += '<span>'+title+arr[j]+'</span><br>';
					}

					if(data[i].abertura && data[i].abertura.data){
						abertura = '<span style="color:red;font-size:7pt"><br><br>Email Visualizado em: '+this.toDate(data[i].abertura.data,false);
						abertura += '<br>Endereço IP: '+data[i].abertura.ip+'</span>'
					}

					if(data[i].msg){
						msg = '<span style="color:red;font-size:7pt" title="'+data[i].msg+'"><i class="fa fa-exclamation-triangle"></i></span> ';
					}

					if(data[i].select_pages){
						select_pages = '<br><span style="color:red;font-size:7.5pt">Páginas selecionadas: '+data[i].select_pages.join(',')+'</span>'
					}

					var item = {
						'data': this.toDate(data[i].created_at,false),
						'usuario': (data[i].usuario ? data[i].usuario.usuario : null),
						'lote': data[i].lote,
						'obs': data[i].obs,
						'remetente': data[i].remetente,
						'destinatario': destinatario,
						'documento': (data[i].tipo_documento ? data[i].tipo_documento.descricao+select_pages : null),
						'status': data[i].msg,
						'consulta': data[i].id_con,
						_data:data[i],
						options:{
						},
						buttons:[]
					};

					tableData.push(item);
				}

				this.pagination = pagination;
				this.tableData = tableData;
				this.loadingTable = false;
			},
		}
  	}
</script>



// WEBPACK FOOTER //
// download-aso-email.vue?008f17b0